import {gql, useQuery} from '@apollo/client'
import {useGetFiltersDataMap} from './getFiltersDataMap'
import {usePersona} from '../../../store/hooks/persona'

export default function useQueryPersonaByCongressionalDistrict() {
  const GET_PERSONA_BY_CONGRESSIONAL_DISTRICT = gql`
    query GetPersonaByCongressionalDistrict($filters: Filters, $benefits: [BenefitEligibility]) {
      personaCongressionalDistrict(filters: $filters, benefits: $benefits) {
        personaCongressionalDistrict {
          state
          congressional_district
          congressional_district_id
          total_population
          dominant_persona
          persona_cohort
          persona_population
          congressionalDistrictPercentage
          statePercentage
        }
        missingGeoIds
      }
    }
  `

  const {filtersDataMap, benefitsData} = useGetFiltersDataMap()
  const {personasToggle} = usePersona()

  const {
    data: personaByCongressionalDistrict,
    loading: loadingPersonaByCongressionalDistrict,
    error: personaByCongressionalDistrictError,
    refetch: refetchPersonaByCongressionalDistrict
  } = useQuery(GET_PERSONA_BY_CONGRESSIONAL_DISTRICT, {
    variables: {
      filters: filtersDataMap,
      benefits: benefitsData[0]
    },
    skip: !personasToggle,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first'
  })

  return {
    personaByCongressionalDistrict,
    loadingPersonaByCongressionalDistrict,
    personaByCongressionalDistrictError,
    refetchPersonaByCongressionalDistrict
  }
}
